<template>
  <v-container>
    <landing-create :content="content"></landing-create>
    <template v-if="freezer">
      <freezer-form
        :isLoading="isLoading"
        :freezer="freezer"
        :onSubmit="onSubmit">
      </freezer-form>
    </template>
  </v-container>
</template>

<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import FreezerForm from './FreezerForm.vue';
import services from '../../../services';
import utilities from '../../../utilities';

const { ErrorMessageUtil } = utilities;
const { biobankRegistry } = services;
const { freezerService } = biobankRegistry;

export default {
  name: 'FreezerUpdate',
  components: {
    FreezerForm,
    LandingCreate,
  },
  data: () => ({
    isLoading: false,
    content: {
      pageTitle: 'Update Freezer',
      enableBackButton: true,
    },
    freezer: null,
  }),
  async created() {
    const { id } = this.$route.params;
    const freezer = await freezerService.getOne({ id });
    this.freezer = freezer;
  },
  methods: {
    async onSubmit(dataChange) {
      const data = Object.assign(this.freezer || {}, dataChange);
      console.log('data update', data);
      this.isLoading = true;
      try {
        await freezerService.update({ freezer: data });

        this.$snackbar.showOk({ text: 'Successfully updated freezer!' });

        this.$router.push({ name: 'freezer.list' });
      } catch (e) {
        const error = e.response.data;
        this.$snackbar.showBad({
          text: ErrorMessageUtil.transform(error),
        });
      }
      this.isLoading = false;
    },
  },
};
</script>
